import { createContext, useState, ReactNode } from "react";
import { MapOfBrands } from "~src/types/brandMapping";

type BrandMappingContextType = {
  mapOfBrandsContext: MapOfBrands[] | undefined;
  setMapOfBrandsContext: React.Dispatch<
    React.SetStateAction<MapOfBrands[] | undefined>
  >;

  mapOfBrandsFullResponseContext: MapOfBrands[] | undefined;
  setMapOfBrandsFullResponseContext: React.Dispatch<
    React.SetStateAction<MapOfBrands[] | undefined>
  >;
};

const BrandMappingContextV2 = createContext<BrandMappingContextType | null>(
  null,
);

const BrandMappingProviderV2 = ({ children }: { children: ReactNode }) => {
  const [mapOfBrandsContext, setMapOfBrandsContext] = useState<
    MapOfBrands[] | undefined
  >([]);
  const [mapOfBrandsFullResponseContext, setMapOfBrandsFullResponseContext] =
    useState<MapOfBrands[] | undefined>([]);

  const contextValue = {
    mapOfBrandsContext,
    setMapOfBrandsContext,

    mapOfBrandsFullResponseContext,
    setMapOfBrandsFullResponseContext,
  };

  return (
    <BrandMappingContextV2.Provider value={contextValue}>
      {children}
    </BrandMappingContextV2.Provider>
  );
};

export { BrandMappingContextV2, BrandMappingProviderV2 };
